import { api } from "./apiBaseQuery";

export const reviewsServices: any = api.injectEndpoints({
  endpoints: (builder) => ({
    getWithdrawalRequests: builder.mutation({
      query: (params) => {
        return {
          url: `/RetirarAsignaturas/Retiros?resolucionId=${params.resolucionId}&estudiante=${params.estudiante}&estadoId=${params.estadoId}&page=${params.page}&rowsCount=${params.rowsCount}`,
          method: "GET",
        };
      },
    }),
    updateWithdrawalRequests: builder.mutation({
      query: (body) => {
        const id = body.id;
        delete body.id;
        return {
          url: `/RetirarAsignaturas/Retiros/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    getWithdrawalStatus: builder.query({
      query: () => {
        return {
          url: `/Resoluciones/EstadosActivos`,
        };
      },
    }),
    getIsTransferActive: builder.mutation({
      query: (body) => {
        return {
          url: `/Estudiantes/EstadoTransferencia`,
          method: "GET",
          body,
        };
      },
    }),
    saveTransferEndorsment: builder.mutation({
      query: (body) => {
        return {
          url: `/PagosTransferencias`,
          method: "POST",
          body,
        };
      },
    }),
    updateTransferStudent: builder.mutation({
      query: (body) => {
        const id = body.id;
        delete body.id;
        return {
          url: `/PagosTransferencias/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    getTransferEndorsments: builder.mutation({
      query: (body) => {
        return {
          url: `/PagosTransferencias/Obtener`,
          method: "POST",
          body,
        };
      },
    }),
    getTransfersStatus: builder.query({
      query: () => {
        return {
          url: `/PagosTransferencias/Estados`,
        };
      },
    }),
    updateTransferEndorsment: builder.mutation({
      query: (body) => {
        return {
          url: `/PagosTransferencias/PagosTransferencias/Update/`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetWithdrawalRequestsMutation,
  useUpdateWithdrawalRequestsMutation,
  useGetWithdrawalStatusQuery,
  useGetTransferEndorsmentsMutation,
  useGetIsTransferActiveMutation,
  useGetTransfersStatusQuery,
  useSaveTransferEndorsmentMutation,
  useGetSponsorshipEndorsmentsMutation,
  useUpdateTransferEndorsmentMutation,
  useUpdateSponsorshipEndorsmentMutation,
  useUpdateTransferStudentMutation,
} = reviewsServices;
